export const users = {
    route: '用户管理',
    routeTitle: '用户管理',
    listOfUsers: '用户列表',
    addUser: '添加用户',
    editUser: '编辑用户',
    deleteUser: '删除用户',
    deleteUserButton: '删除',
    deleteUserConfirmTitle: '确定删除该用户?',
    deleteUserConfirmDescription: ['用户', '将被删除.'],
    loginLabel: '登录',
    firstNameLabel: '名',
    lastNameLabel: '名称',
    passwordLabel: '密码',
    permissionsLabel: '权限',
    permissionsIsAdminTag: '管理员',
    permissionsIsTesterTag: '测试人员',
    permissionsIsNotAdminTag: '用户',
    oldPasswordLabel: '原密码',
    newPasswordLabel: '新密码',
    confirmNewPasswordLabel: '新确认密码',
    confirmPasswordLabel: '确认密码',
    confirmPasswordNotCorrect: '你好, 密码不一致，重新修改?',
    addUserAsAdmin: '设为管理员',
    addUserAsTester: '设为测试人员',
    addUserAsInstaller: '设为安装人员',
    changeUserPassword: '修改用户密码'
};
